import React from "react";
import { render } from "react-dom";
import { Input } from "uxp/components";
import { bindContainerId } from "../../../../util";
import jp from 'jsonpath'
import { findAvailableFields, IUIPropertyDefinition } from "../../../common/common";
import { ColorPickerDialog, CustomColorPicker, Property, PropertyContainer, PropertyGroup, PropertyTitle } from "../../../common/ui-props/common";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export interface IFooterProps {
    firstValueLabel?: string;
    secondValueLabel?: string;
    firstValueLabelColor?: string;
    secondValueLabelColor?: string;
}
export interface INewColorButton {
    onAddNew: (colorForRange: { color: string, stopAt: number }) => void,
}

export const NewColorButton: React.FunctionComponent<INewColorButton> = (props) => {

    const [showColorPicker, setShowColorPicker] = React.useState<boolean>(false)
    const [newColorForRange, setNewColorForRange] = React.useState<{ color: string, stopAt: number }>()

    let addButtonRef = React.useRef(null)

    React.useEffect(() => {
        setNewColorForRange({ ...newColorForRange, stopAt: 3 })
    }, [showColorPicker])

    return (
        <>
            <div
                className="plus"
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '14px',
                    cursor: 'pointer'
                }}
                ref={addButtonRef}
                onClick={() => {
                    setShowColorPicker(true)
                }}
            >
                <FontAwesomeIcon icon={['fas', 'plus']} />
            </div>

            <ColorPickerDialog
                onClose={() => {
                    setShowColorPicker(false)
                    if (newColorForRange) {
                        props.onAddNew(newColorForRange)
                    }
                }}
                show={showColorPicker}
                onChange={(v) => setNewColorForRange({
                    color: v.color,
                    stopAt: v.from,
                })}
                triggerButtonRef={addButtonRef}
                colorForRange={{
                    color: newColorForRange?.color,
                    from: newColorForRange?.stopAt,
                }}
            />
        </>
    )
}

export function footerProperty(title: string, props: IFooterProps): IUIPropertyDefinition<IFooterProps> {
    return {
        defaults: props,
        render: (props, uxpContext, data, containerId) => {
            let _props = props.uiProps
            let possibleValues = {};
            findAvailableFields(props.parentUIProps.source, props.parentUIProps.datasources, possibleValues);
            let pv = Object.keys(possibleValues);
            pv.sort();
            console.log(containerId)
            return <PropertyContainer>
                <PropertyGroup>
                <Property id={bindContainerId('firstValueLabel', containerId)}>
                                <PropertyTitle>Label</PropertyTitle>
                                <Input
                                    value={_props.firstValueLabel || ''}
                                    onChange={s => {
                                        jp.apply(_props, '$.firstValueLabel', () => (s))
                                        props.onChange(Object.assign({},_props));
                                    }}
                                    className="widget-designer-input"
                                />

                            </Property>

                            <Property>
                                <PropertyTitle>Label Color</PropertyTitle>
                                <CustomColorPicker contextData={props.contextData}
                                    color={_props.firstValueLabelColor || 'white'}
                                    onChange={s => {
                                        jp.apply(_props, '$.firstValueLabelColor', () => (s))
                                        props.onChange(Object.assign({},_props));
                                    }}

                                />

                            </Property>
                            </PropertyGroup>
                            <PropertyGroup>
                            <Property id={bindContainerId('secondValueLabel', containerId)}>
                                <PropertyTitle>Label</PropertyTitle>
                                <Input
                                    value={_props.secondValueLabel || ''}
                                    onChange={s => {
                                        jp.apply(_props, '$.secondValueLabel', () => (s))
                                        props.onChange(Object.assign({},_props));
                                    }}
                                    className="widget-designer-input"
                                />

                            </Property>
                            <Property>
                                <PropertyTitle>Label Color</PropertyTitle>
                                <CustomColorPicker contextData={props.contextData}
                                    color={_props.secondValueLabelColor || 'white'}
                                    onChange={s => {
                                        jp.apply(_props, '$.secondValueLabelColor', () => (s))
                                        props.onChange(Object.assign({},_props));
                                    }}

                                />

                            </Property>
                </PropertyGroup>
            </PropertyContainer>
        }
    };

}